var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayplus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3336 15.668V16.3346C25.3336 16.7028 25.0352 17.0013 24.667 17.0013H17.0003V24.668C17.0003 25.0361 16.7018 25.3346 16.3336 25.3346H15.667C15.2988 25.3346 15.0003 25.0361 15.0003 24.668V17.0013H7.33366C6.96547 17.0013 6.66699 16.7028 6.66699 16.3346V15.668C6.66699 15.2998 6.96547 15.0013 7.33366 15.0013H15.0003V7.33463C15.0003 6.96644 15.2988 6.66797 15.667 6.66797H16.3336C16.7018 6.66797 17.0003 6.96644 17.0003 7.33463V15.0013H24.667C25.0352 15.0013 25.3336 15.2998 25.3336 15.668Z",
    fill: "#5B6871"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayplus);
export default __webpack_public_path__ + "static/media/grayplus.5c0fdd55e4fc98403bfa076babc37445.svg";
export { ForwardRef as ReactComponent };